import { render, staticRenderFns } from "./scheduleMessage.vue?vue&type=template&id=5c18feb6"
import script from "./scheduleMessage.vue?vue&type=script&lang=js"
export * from "./scheduleMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports